// services/everpro/everpro-shipping/rates/body.ts — build rates request body
import type { GetRatesParams } from '../../everpro-types';

export function buildRatesBody(params: GetRatesParams): Record<string, any> {
  const dimensionCm = params.dimensionCm || { length: 10, width: 10, height: 10 };

  const body: Record<string, any> = {
    origin_postal_code: params.originPostalCode,
    destination_postal_code: params.destinationPostalCode,
    // Nama desa MEMBANTU Everpro match rute (dok: tanpa ini kode pos valid pun
    // bisa 404). Selalu kirim bila ada — insiden Gunungsitoli 22810 (2026-10-01).
    ...(params.originSubDistrictName ? { origin_sub_district_name: params.originSubDistrictName } : {}),
    ...(params.destinationSubDistrictName ? { destination_sub_district_name: params.destinationSubDistrictName } : {}),
    weight: params.weightKg,
    item_price: Math.round(params.itemPrice > 0 ? params.itemPrice : 1),
    package_type_id: 1,
    shipment_type: params.shipmentType ?? 'DROP',
    is_cod: params.isCOD ?? false,
    is_use_insurance: false,
    height: Math.ceil(dimensionCm.height),
    width: Math.ceil(dimensionCm.width),
    length: Math.ceil(dimensionCm.length),
    // Flat rate Everpro = tarif promo/agreement yang TIDAK memperhitungkan jarak.
    // Bahaya: ke luar Jawa ia jadi "termurah" padahal jauh di bawah tarif riil
    // (Medan iD 11.500 flat vs 36.100 riil; NTT SiCepat 8.500 vs 20.000 riil)
    // → kalau ditagih Everpro tarif riil saat booking, merchant RUGI besar.
    // Default false (2026-10-14); true HANYA bila merchant nyalakan toggle
    // flatRate per-brand (includeFlatRate) dan paham risikonya.
    include_flat_rate: params.includeFlatRate ?? false,
  };
  if (params.isCOD) {
    body.cod_price = Math.round(params.codPrice || params.itemPrice || 1);
  }
  return body;
}
